/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RelationReportsControllerGetOrgChartReport200ResponseDataDataInnerUser } from './relationReportsControllerGetOrgChartReport200ResponseDataDataInnerUser';
import { EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataRelationTypesInner } from './evaluationsReportControllerGetEvaluationResultsReport200ResponseDataRelationTypesInner';


export interface RelationReportsControllerGetOrgChartReport200ResponseDataDataInner { 
    id?: string;
    user?: RelationReportsControllerGetOrgChartReport200ResponseDataDataInnerUser;
    relatedUser?: RelationReportsControllerGetOrgChartReport200ResponseDataDataInnerUser;
    relationType?: EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataRelationTypesInner;
    isCustom?: boolean;
    /**
     * Fecha de finalización; solo viene con where.includeEnded = true
     */
    endedOn?: string | null;
    createdOn?: string;
    modifiedOn?: string;
}

